export const isFormattedPhone = (phone) =>
  /^\([0-9]{3}\)\s?[0-9]{3}-[0-9]{4}/.test(phone);
